import HttpService from "common/http/httpService";
import { DeliveryMethodDetails } from "domain/deliveryMethod";


class DeliveryMethodService extends HttpService {
    async listDeliveryMethods(): Promise<DeliveryMethodDetails[]> {
        const response = await this.getClient().get<DeliveryMethodDetails[]>('/settings/v1/delivery-methods');
        return response.data;
    }
}
const deliveryMethodService = new DeliveryMethodService();
export default deliveryMethodService;
